import React from 'react';
import equal from 'fast-deep-equal';
import FieldSection from './FieldSection';
import SectionNavigator from './SectionNavigator';
import ColorArray from 'rainbow-colors-array';
import TotalPage from './TotalPage';
import SendPage from './SendPage';

export default class Co2Calculator extends React.Component {
  constructor(props, ref) {
    super(props, ref);

    this.hostNode;
    this.ColorArray = ColorArray;
    this.form = React.createRef();
    this.navContainer = React.createRef();
    this.containerSelector = document.getElementById('co2CalculatorContainer');

    this.state = {
      emmisionElements: this.containerSelector
        .querySelector('div:first-of-type')
        .shadowRoot.querySelectorAll('.co2calculator__input--display--true'),
      data: [],
      setActive: (targetKey) => {
        document
          .getElementById('co2CalculatorContainer')
          .scrollIntoView({ alignToTop: true, behavior: 'smooth' });
        this.setState({ currentActive: targetKey });
        //debugger;
      },
      currentActive: 0,
      total: 0,
      isFilled: [],
      setFilled: (item) => {
        let joined = this.state.isFilled;
        if (!this.state.isFilled.includes(item)) joined = this.state.isFilled.concat(item);

        this.setState({ isFilled: joined });
      },
      changeRelative: (index) => {
        this.setState(
          {
            emmisionElements: this.containerSelector
              .querySelector('div:first-of-type')
              .shadowRoot.querySelectorAll('.co2calculator__input--display--true'),
          },
          () => {
            //console.log(this.state.emmisionElements);

            let values = [];
            [].forEach.call(this.state.emmisionElements, (input) => {
              values.push(Number(input.value));
            });

            const reducer = (a, b) => a + b;
            this.setState({ total: values.reduce(reducer, 0) }, () => {
              this.state.chartData();
              this.state.calcTotals();
            });
          },
        );
      },
      chartData: () => {
        return this.chartData();
      },
      calcTotals: () => {
        this.calcTotals();
      },
      allTotals: {
        co2Totals: 0,
        relTotals: 0,
        costTotals: 0,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props.data, prevProps.data)) {
      // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
      this.setState({ data: this.props.data.acf.segments });
    }

    this.getSectionNames();
  }

  getSectionNames() {
    let nameArray = [];

    this.state.data.map((element, key) => {
      nameArray.push(element.name);
    });

    return nameArray;
  }

  chartData() {
    this.hostNode = this._reactInternalFiber.child.stateNode;
    this.nameArray = [];

    this.state.data.map((segments, key) => {
      if (segments.segment === false) return;

      segments.segment.map((item, key) => {
        this.nameArray.push(item.item.name);
      });
    });

    this.dataArray = [];

    const relativeFields = this.hostNode.getElementsByClassName('co2calculator__input--relative');
    [].forEach.call(relativeFields, (field, key) => {
      this.dataArray[key] = field.value;
    });

    const colorObject = this.ColorArray(this.nameArray.length, 'hex', true);
    let ColorArray = [];

    [].forEach.call(colorObject, (color) => {
      ColorArray.push(`#${color.hex}`);
    });

    const dataObject = {
      labels: this.nameArray,
      datasets: [
        {
          data: this.dataArray,
          backgroundColor: ColorArray,
          borderColor: ColorArray,
          borderWidth: 1,
        },
      ],
    };

    return dataObject;
  }

  ifMax(index) {
    if (index === this.state.data.length - 1) return true;
    else return false;
  }

  arrSum(arr) {
    return arr.reduce(function (a, b) {
      return a + b;
    }, 0);
  }

  calcTotals() {
    const hostNode = this.hostNode;

    let totalObject = {
      co2Totals: this.state.total,
      relTotals: 0,
      costTotals: 0,
    };

    const relFields = hostNode.getElementsByClassName('co2calculator__input--relative');
    const priceFields = hostNode.getElementsByClassName('co2calculator__input--price');

    let relArray = [];
    let priceArray = [];

    [].forEach.call(relFields, (field, index) => {
      relArray.push(Number(field.value));
    });
    [].forEach.call(priceFields, (field, index) => {
      priceArray.push(Number(field.value));
    });

    totalObject.relTotals = this.arrSum(relArray).toFixed(2);
    totalObject.costTotals = this.arrSum(priceArray).toFixed(2);

    //console.log(totalObject);

    this.setState({ allTotals: totalObject });
    return totalObject;
  }

  render() {
    return (
      <div className='co2calculator__wrapper'>
        <SectionNavigator
          items={this.getSectionNames()}
          setActive={this.state.setActive}
          currentActive={this.state.currentActive}
          filledItems={this.state.isFilled}
          ref={this.navContainer}
        />
        <form ref={this.form}>
          {this.state.data.map((element, key) => (
            <FieldSection
              key={key}
              name={element.name}
              items={element.segment}
              index={key}
              currentActive={this.state.currentActive}
              changeRelative={this.state.changeRelative}
              total={this.state.total}
              setActive={this.state.setActive}
              setFilled={(item) => {
                this.state.setFilled(item);
              }}
              isFinal={this.ifMax(key)}
            />
          ))}

          <TotalPage
            currentActive={this.state.currentActive}
            chartData={this.state.chartData}
            setActive={this.state.setActive}
            allTotals={this.state.allTotals}
          />
        </form>
        <SendPage
          currentActive={this.state.currentActive}
          forwardRef={this.form}
          hostNode={this.props.forwardRef.current}
        />
      </div>
    );
  }
}
